"use client";

import { cn } from "@/lib/utils";
import { CheckIcon, FileTextIcon, XIcon } from "lucide-react";
import striptags from "striptags";

export const QuizOption = ({
  option,
  onSelect,
  isAfterSelect = false,
  isSelected = false,
  onShowComment,
  quizHasMultipleCorrect,
  isCommentActive = false,
  showCommentIcon,
}: {
  option: QuizOption;
  onSelect: () => void;
  isAfterSelect?: boolean;
  isSelected?: boolean;
  onShowComment: () => void;
  quizHasMultipleCorrect: boolean;
  isCommentActive?: boolean;
  showCommentIcon: boolean;
}) => {
  const isCorrect = option.correct;

  return (
    <li
      className={cn(
        "relative flex cursor-pointer items-center justify-between gap-2 rounded-[10px] border px-4 transition-all",
        (isAfterSelect || isSelected) && "pointer-events-none",
        isAfterSelect &&
          !isCorrect &&
          !isSelected &&
          "text-muted-foreground border-zinc-300",
        isAfterSelect &&
          !isCorrect &&
          isSelected &&
          "border-red-700 bg-red-700/5 text-red-700",
        isAfterSelect &&
          isCorrect &&
          "border-teal-600 bg-teal-50 text-teal-700",
        isSelected && isCorrect && "border-teal-600 bg-teal-50 text-teal-700",
        !isAfterSelect &&
          !isSelected &&
          "hover:border-remedium-blue/20 hover:-translate-y-[2px] hover:bg-[#F9F9FF]",
        isCommentActive && "!border-blue-400 !bg-blue-50 !text-blue-700",
      )}
      onClick={onSelect}
    >
      <div
        className={cn(
          "flex h-full flex-1 cursor-pointer items-center gap-2 py-2.5",
          isAfterSelect && "pointer-events-none",
        )}
        onClick={onSelect}
      >
        <span
          className={cn(
            "flex h-4 w-4 flex-shrink-0 items-center justify-center border border-[#18181B]",
            isAfterSelect && !isSelected && !isCorrect && "border-zinc-300",
            isAfterSelect && isCorrect && "border-none bg-teal-700",
            isAfterSelect &&
              !isCorrect &&
              isSelected &&
              "border-none bg-red-700",
            isSelected && isCorrect && "border-none bg-teal-700",
            quizHasMultipleCorrect ? "rounded-sm" : "rounded-full",
          )}
        >
          {isAfterSelect && isSelected && !isCorrect && (
            <XIcon className="h-3 w-3" color="white" />
          )}
          {(isAfterSelect || isSelected) && isCorrect && (
            <CheckIcon className="h-3 w-3" color="white" />
          )}
        </span>
        <span
          className="text-sm"
          dangerouslySetInnerHTML={{
            __html: striptags(option.description, ["sup", "sub", "em", "span"]),
          }}
        ></span>
      </div>
      {!isSelected && isAfterSelect && showCommentIcon && (
        <div
          className="realative pointer-events-auto z-20 cursor-pointer"
          data-title={"pokaż komentarz"}
          onClick={onShowComment}
        >
          <FileTextIcon className="size-5 text-blue-600" />
        </div>
      )}
    </li>
  );
};
